import { MoreOutlined } from '@ant-design/icons'
import { Button, Dropdown, Menu } from 'antd'

import { sortNumericColumn, sortStringColumn } from '../../../../components/tables/utils'
import { IssuerComplianceRule } from './models'

const renderActionsMenu =
  ({
    onDelete,
    onUpdate,
  }: {
    onUpdate: (record: IssuerComplianceRule) => void
    onDelete: (issuerComplianceRule: IssuerComplianceRule) => void
  }) =>
  (_: any, record: IssuerComplianceRule) => {
    const menu = (
      <Menu>
        <Menu.Item key="updateTrade" onClick={() => onUpdate(record)}>
          Update Compliance Rule
        </Menu.Item>
        <Menu.Item key="createTrade" onClick={() => onDelete(record)}>
          Delete Compliance Rule
        </Menu.Item>
      </Menu>
    )

    return (
      <Dropdown placement="bottomRight" overlay={menu}>
        <Button icon={<MoreOutlined />} />
      </Dropdown>
    )
  }

export const buildIssuerComplianceRulesTableColumns = ({
  onUpdate,
  onDelete,
}: {
  onUpdate: (issuerComplianceRule: IssuerComplianceRule) => void
  onDelete: (issuerComplianceRule: IssuerComplianceRule) => void
}) => [
  {
    title: 'ID',
    dataIndex: 'id',
    sorter: sortNumericColumn({ dataIndex: 'id' }),
  },
  {
    title: 'Rating Type',
    dataIndex: 'ratingType',
    sorter: sortStringColumn({ dataIndex: 'ratingType' }),
  },
  {
    title: 'Rating',
    dataIndex: 'rating',
    sorter: sortStringColumn({ dataIndex: 'rating' }),
  },
  {
    title: 'Max Limit',
    dataIndex: 'maxLimit',
    sorter: sortNumericColumn({ dataIndex: 'maxLimit' }),
  },
  { title: '', render: renderActionsMenu({ onDelete, onUpdate }) },
]
